import { FunctionComponent } from "react";
import Map, { Source, Layer, LineLayer, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Feature } from "geojson";
import { JesprRoute } from "./Route";

const MAPBOX_STYLE = "robertoehler/ckses8ubo25xx18nvizkw2e0l";

interface Props {
  route: JesprRoute;
}

const RouteMap: FunctionComponent<Props> = ({ route }) => {
  const bounds: [[number, number], [number, number]] = [
    [90, 90],
    [-90, -90],
  ];
  for (const dp of route.dataPoints) {
    if (dp.coordinates[0] < bounds[0][1]) {
      bounds[0][1] = dp.coordinates[0];
    }
    if (dp.coordinates[1] < bounds[0][0]) {
      bounds[0][0] = dp.coordinates[1];
    }
    if (dp.coordinates[0] > bounds[1][1]) {
      bounds[1][1] = dp.coordinates[0];
    }
    if (dp.coordinates[1] > bounds[1][0]) {
      bounds[1][0] = dp.coordinates[1];
    }
  }

  const feature: Feature = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: route.dataPoints.map((dp) =>
        dp.coordinates.slice().reverse(),
      ),
    },
  };

  const layer: LineLayer = {
    id: "route",
    type: "line",
    source: "",
    layout: {
      "line-join": "round",
      "line-cap": "round",
    },
    paint: {
      "line-color": "#00f096",
      "line-width": 5,
    },
  };

  return (
    <Map
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      initialViewState={{
        bounds,
        fitBoundsOptions: {
          padding: 50,
        },
      }}
      scrollZoom={false}
      mapStyle={`mapbox://styles/${MAPBOX_STYLE}`}
    >
      <Source type="geojson" data={feature}>
        <Layer {...layer} />
      </Source>
      <NavigationControl />
    </Map>
  );
};

export default RouteMap;
